import {
  PagePermission,
  TabPermission,
} from 'src/app/core/interfaces/permissions';
import { PermissionsC } from 'src/permissions/helpers/permissions.class';
import { BrandSettings } from '../../brand-settings.setup';
import {
  BrandSettingsGeneralBillOnBillToTab,
  BrandSettingsGeneralTopUpTab,
  BrandSettingsGeneralPaymentChannelsTab
} from './tabs';

const parent = BrandSettings.pages.general;
const title = 'PAGE.BRAND_SETTINGS.GENERAL.TITLE';
const tabs: TabPermission[] = [
  BrandSettingsGeneralTopUpTab,
  BrandSettingsGeneralBillOnBillToTab,
  BrandSettingsGeneralPaymentChannelsTab,
];

export const BrandSettingsGeneralPage: PagePermission =
  PermissionsC.generatePagePermission(parent, title, tabs);
